<template>
  <div>
    <b-card class="mt-4">
      <b-overlay :show="busy" rounded="sm">
        <div class="row pb-3">
          <div class="col">
            <h3>Temperówki</h3>
          </div>
          <div class="col">
            <button type="button" class="btn btn-primary float-right" @click="AddItem">
              <i class="fas fa-plus-circle fa-1x"></i> Dodaj temperówkę
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 font-weight-bold">Nazwa</div>
          <div class="col-md-2 font-weight-bold">Rozmiar</div>
          <div class="col-md-3 font-weight-bold">Numer seryjny</div>
          <div class="col-md-3 font-weight-bold">Tunel chłodniczy</div>
          <div class="col-md-1 font-weight-bold">Akcje</div>
        </div>
        <div class="row p-1" v-for="item in chocolateSharpeners" :key="item.id">
          <div class="col-md-3">
            <input type="text" :disabled="!item.isEdit" class="form-control" v-model="item.name" />
          </div>
          <div class="col-md-2">
            <v-select :options="chocolateSharpenerSizes" :disabled="!item.isEdit" label="name" v-model="item.size"
              :reduce="(x) => x.id" @input="ClearCoolingTunnel(item)"></v-select>
          </div>
          <div class="col-md-3">
            <input type="text" :disabled="!item.isEdit" class="form-control" v-model="item.serialNumber" />
          </div>
          <div class="col-md-3">
            <v-select :options="coolingTunnels" :disabled="!item.isEdit" label="name" v-model="item.coolingTunnelId"
              :reduce="(x) => x.id" v-if="item.size == 2"></v-select>
            <div class="alert alert-warning" v-else>
              <small>Tylko duża temperówka może mieć przypisany tunel chłodniczy na
                stałe</small>
            </div>
          </div>
          <div class="col-md-1 div-icons-area">
            <div class="row">
              <div class="col-xs">
                <span @click="SaveData(item)" v-if="item.isEdit"><i class="fas fa-check fa-lg color-green"></i></span>
                <span v-if="!item.isEdit" @click="ChangeEditStatus(item, true)" v-b-tooltip.hover
                  title="Edytuj temperówkę">
                  <i class="fas fa-edit fa-lg"></i></span>
              </div>
              <div class="col-xs">
                <span @click="ChangeEditStatus(item, false)" v-if="item.isEdit">
                  <i class="fas fa-times fa-lg color-red"></i>
                </span>
                <span v-b-tooltip.hover title="Usuń temperówkę" v-if="!item.isEdit"
                  @click="RemoveChocolateSharpener(item)">
                  <i class="fas fa-trash fa-lg"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import chocolateSharpenerMixin from "../../../mixins/chocolateSharpenerMixin";

import axios from "axios";

export default {
  name: "AdministrationChocolateSharpener",
  components: {},
  mixins: [urlConfig, toastr, chocolateSharpenerMixin],
  mounted() {
    this.loadChocolateSharpeners();
    this.$store.dispatch("CoolingTunnel/getCoolingTunnels");
    this.isLoaded = true;
  },
  computed: {
    coolingTunnels() {
      return this.$store.state.CoolingTunnel.coolingTunnels;
    },

  },
  data() {
    return {
      localCopy: [],
      isLoaded: false,
      busy: false,
      chocolateSharpeners: [],
    };
  },
  methods: {
    loadChocolateSharpeners() {
      const that = this;
      this.getChocolateSharpeners()
        .then((res) => {
          const result = res.data;
          if (result.success) {
            res.data.data.forEach((item) => {
              that.chocolateSharpeners.push({ ...item, isEdit: false });
            });
          } else {
            that.DisplayError("Błąd", "Nie udało się pobrać listy temperówek")
          }
        })
        .catch(() => {
          that.DisplayError("Błąd", "Nie udało się pobrać listy temperówek")
        })
    },
    ClearCoolingTunnel(item) {
      if (
        item.size ==
        this.chocolateSharpenerSizes.filter((x) => x.name == "Mały")[0].id
      ) {
        item.coolingTunnelId == undefined;
      }
    },
    IsValid(item) {
      if (item.size == 1) {
        if (!item.name || !item.size || !item.serialNumber) {
          this.DisplayError("Błąd!", "Nie wszystkie pola są wypełnione");
          return false;
        }
        return true;
      } else {
        if (
          !item.name ||
          !item.size ||
          !item.serialNumber ||
          !item.coolingTunnelId
        ) {
          this.DisplayError("Błąd!", "Nie wszystkie pola są wypełnione");
          return false;
        }
        return true;
      }
    },
    AddItem() {
      this.chocolateSharpeners.unshift({ isEdit: true });
    },
    SaveData(item) {
      if (item.machineId) {
        this.UpdateChocolateSharpener(item);
      } else {
        this.SaveNewCoolingTunnel(item);
      }
    },
    SaveNewCoolingTunnel(item) {
      if (this.IsValid(item)) {
        var url = this.url.serverUrl + this.url.ChocolateSharpener.Create;
        var that = this;
        this.busy = true;
        axios
          .post(url, item)
          .then(function (response) {
            if (response.data.success) {
              item.isEdit = false;
              item.id = response.data.data.id;
              that.DisplaySuccess(
                "Sukces!",
                "Nowa temperówka '" + item.name + "' została dodana"
              );
            } else {
              that.DisplayError("Błąd!", response.data.errors[0]);
            }
            that.busy = false;
          })
          .catch(function (e) {
            that.busy = false;
            that.DisplayError("Błąd!", e);
            console.log(e);
          });
      }
    },
    UpdateChocolateSharpener(item) {
      var url = this.url.serverUrl + this.url.ChocolateSharpener.Update;
      var that = this;
      this.busy = true;
      axios
        .post(url, item)
        .then(function (response) {
          if (response.data.success) {
            item.isEdit = false;
            that.DisplaySuccess("Sukces!", "Temperówka została zaktualizowana");
          } else {
            that.DisplayError("Błąd!", response.data.errors[0]);
          }
        })
        .catch(function (e) {
          that.DisplayError("Błąd!", e);
          console.log(e);
        })
        .finally(function () {
          that.busy = false;
        });
    },
    RemoveChocolateSharpener(item) {
      if (confirm("Czy napewno chcesz usunać temperówkę: " + item.name)) {
        var that = this;
        this.busy = true;
        axios
          .delete(
            `${this.url.serverUrl}${this.url.ChocolateSharpener.Remove}${item.machineId}`
          )
          .then(function (response) {
            if (response.data.success) {
              var index = that.chocolateSharpeners.findIndex(
                (x) => x.id == item.id
              );
              that.chocolateSharpeners.splice(index, 1);
              that.busy = false;
              that.DisplaySuccess("Sukces!", "Temperówka została usunięta");
            } else {
              that.DisplayError("Błąd!", response.data.errors[0]);
            }
          })
          .catch(function (e) {
            console.log(e);
            that.DisplayError("Błąd!", e);
            that.busy = false;
          });
      }
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        this.localCopy.push(Object.assign({}, item));
      } else {
        if (!item.id) {
          var index = this.coolingTunnels.findIndex((x) => x.id == undefined);
          this.coolingTunnels.splice(index, 1);
        }
        var rootItem = this.localCopy.filter((x) => x.id == item.id)[0];
        item.name = rootItem.name;
        item.size = rootItem.size;
        item.serialNumber = rootItem.serialNumber;
        this.localCopy = this.localCopy.filter((x) => x.id != item.id);
      }
      item.isEdit = status;
    },
  },
};
</script>